import * as React from 'react'
import {
  OpportunityIcon,
  TablePagination,
  useTablePagination,
} from '@sales-center/components'
import { tableStyles } from './useTableStyles'
import { useGetLocationOppsByPage } from '@user/store/oppSummary/useGetLocationOppsByPage'
import format from 'date-fns/format'
import { toast } from '@sales-center/components'
import { EmptyRows } from './EmptyRows'
import Table from '@mui/material/Table'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import TableBody from '@mui/material/TableBody'
import Box from '@mui/material/Box'
import TableFooter from '@mui/material/TableFooter'
import LinearProgress from '@mui/material/LinearProgress'

interface Props {
  externalLinkeId: string
  perPage?: number
}

export const OppSummaryTable: React.FC<Props> = ({
  externalLinkeId,
  perPage = 5,
}) => {
  const { page, onChangePage } = useTablePagination()
  const {
    status,
    result: { count, items },
  } = useGetLocationOppsByPage(externalLinkeId, page + 1, perPage)

  const emptyRows = count > items.length ? perPage - items.length : 0

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell sx={tableStyles.header}>
            <OpportunityIcon width={42} height={42} />
          </TableCell>
          <TableCell sx={tableStyles.header}>
            Date Created &amp; Closed
          </TableCell>
          <TableCell sx={tableStyles.header}>Name</TableCell>
          <TableCell sx={tableStyles.header}>Stage</TableCell>
          <TableCell sx={tableStyles.header}>Owner</TableCell>
          <TableCell sx={tableStyles.header}>Value</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {items.map((i) => (
          <TableRow key={i.id}>
            <TableCell sx={tableStyles.manageLink}>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault()
                  toast.error('not implemented')
                }}
              >
                Manage
              </a>
            </TableCell>
            <TableCell>
              <Box display="inline" mr={2}>
                {i.createdDate !== null
                  ? format(i.createdDate, 'MM/dd/yy')
                  : '-'}
              </Box>
              <Box display="inline">
                {i.closedDate !== null ? format(i.closedDate, 'MM/dd/yy') : '-'}
              </Box>
            </TableCell>
            <TableCell>{i.name}</TableCell>
            <TableCell>{i.stage}</TableCell>
            <TableCell>{i.owner === null ? 'Unassigned' : i.owner}</TableCell>
            <TableCell>${i.value}</TableCell>
          </TableRow>
        ))}
        <EmptyRows rows={emptyRows} columns={7} />
      </TableBody>
      <TableFooter>
        <TableRow>
          <TableCell colSpan={7} sx={tableStyles.footerCell}>
            <Box sx={tableStyles.footerContainer}>
              {status === 'pending' && (
                <LinearProgress color="primary" sx={tableStyles.loading} />
              )}
              {count > perPage && (
                <TablePagination
                  sx={tableStyles.pagination}
                  page={page}
                  perPage={perPage}
                  onChange={onChangePage}
                  resultCount={count}
                  disabled={status === 'pending'}
                />
              )}
            </Box>
          </TableCell>
        </TableRow>
      </TableFooter>
    </Table>
  )
}
OppSummaryTable.displayName = 'OppSummaryTable'
